import { useEffect, useState } from "react";
import { Dialog, DialogCancelButton } from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";

export function MaStornoDialog({
  open,
  maNummer,
  loading,
  onClose,
  onConfirm,
}: {
  open: boolean;
  maNummer: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: (grund: string) => void;
}) {
  const [grund, setGrund] = useState("");

  useEffect(() => {
    if (open) setGrund("");
  }, [open]);

  const trimmed = grund.trim();
  const canSubmit = trimmed.length > 0;

  return (
    <Dialog
      open={open}
      onClose={loading ? () => {} : onClose}
      dirty={trimmed.length > 0}
      size="sm"
      zIndexClass="z-[130]"
      title="Materialanforderung stornieren"
      footer={
        <>
          <DialogCancelButton onClose={onClose} disabled={loading} />
          <Button
            type="button"
            variant="danger"
            disabled={!canSubmit}
            loading={loading}
            onClick={() => onConfirm(trimmed)}
          >
            Stornieren
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        <p className="text-sm leading-relaxed text-label-secondary">
          Materialanforderung{" "}
          <span className="font-semibold text-label">{maNummer}</span> wirklich stornieren?
          Die Anforderung wird abgelehnt und ist für den Monteur nicht mehr bearbeitbar.
        </p>
        <div className="space-y-1">
          <label className="eh-label" htmlFor="ma-storno-grund">
            Stornierungsgrund<span className="ml-1 text-status-red">*</span>
          </label>
          <textarea
            id="ma-storno-grund"
            className="eh-input min-h-[5rem]"
            rows={4}
            placeholder="Bitte kurz begründen …"
            value={grund}
            disabled={loading}
            onChange={(e) => setGrund(e.target.value)}
          />
        </div>
      </div>
    </Dialog>
  );
}
